<template>
  <div>
    <el-row style="margin: 25px 0;">
      <el-col :sm="3" style="padding-top: 10px">
        <el-button size="mini" icon="el-icon-arrow-left" @click="m__back_to_list">{{ $t('base.back') }}</el-button>
      </el-col>
      <el-col :sm="21">
        <div style="display: flex; gap: 40px">
          <div>
            <p style="font-size: 14px">
              {{ $t('base.time_slot') }}:
              <template v-if="flash_sale">
                {{ flash_sale.start_time * 1000 | moment('HH:mm') }}
                {{ flash_sale.start_time * 1000 | moment('DD-MM-YYYY') }}
                {{ flash_sale.end_time * 1000 | moment('HH:mm') }}
              </template>
            </p>
            <span style="color: #666">
              ID: {{ flash_sale.flash_sale_id }}
              -
              {{ $t('base.status') }}:
              <template v-if="flash_sale">
                <template v-if="flash_sale.type === 1"> {{ $t('base.upcoming') }}</template>
                <template v-if="flash_sale.type === 2"> {{ $t('base.ongoing') }}</template>
                <template v-if="flash_sale.type === 3"> {{ $t('base.expired') }}</template>
              </template>
            </span>
          </div>
          <div>
            <p style="font-size: 14px;">{{ $t('flash_sale.create_title') }}</p>
            <span style="color: #666">{{ $t('flash_sale.you_have_enabled') }} <span style="color: orangered">{{
                product_selected_list.length
              }}/10</span> {{ $t('flash_sale.products_for_selected_time_slots') }}.</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row style="margin-bottom: 20px">
      <el-col :sm="24" class="text-right">
        <el-button type="info" size="mini" icon="el-icon-sort"
                   @click="m__show_change_product_position_dialog('product_selected_list')">
          {{ $t('flash_sale.change_product_position') }}
        </el-button>
        <el-button size="mini" icon="el-icon-info" type="info" @click="m__show_flash_sale_files_dialog">
          {{ $t('flash_sale.saved_file') }}
        </el-button>
        <el-button size="mini" type="primary" icon="el-icon-upload"
                   @click="m__show_import_product_dialog('flash_sale')">
          {{ $t('flash_sale.import_products') }}
        </el-button>
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="m__show_select_product_dialog">
          {{ $t('base.add_products') }}
        </el-button>
        <el-button v-if="m__is_fs()" size="mini" type="primary" icon="el-icon-plus"
                   @click="m__show_select_product_suggest_dialog"
                   :disabled="loading_get_products">
          {{ $t('base.add_recommend_products') }}
        </el-button>
        <el-button size="mini" type="primary" icon="el-icon-check" @click="m__save_and_apply"
                   :loading="loading.save_and_apply">{{ $t('base.save_and_apply') }}
        </el-button>
      </el-col>
    </el-row>

    <Component_FlashSaleProduct
      :id="'update-sticky'"
      :seller="seller"
      :product_selected_list.sync="product_selected_list"
      :flash_sale_created="flash_sale_created"
      :is_edit_component="true"
      :flash_sale="flash_sale"
      :shop_id="shop_id"
      :shopee_id="shopee_id"
      :get_data="loading.get_data"
      :shop="shop"
      @m__remove_product="m__remove_product"
      @m__get_flash_sale_files="m__get_flash_sale_files">
    </Component_FlashSaleProduct>


    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_dialog.select_product"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-row type="margin-top: 10px">
          <el-col :sm="12">
            <p v-if="loading_get_products"><span class="el-icon-loading"></span>
              <strong style="font-size: 18px" class="text-danger">
                {{ $t('base.loading_products') }}</strong></p>
            <p v-else><strong style="font-size: 18px">{{ $t('select.products') }}
              <a href="javascript:void(0)" style="font-size: 14px" @click="m__get_product">
                ({{ $t('base.update_data') }})
              </a></strong>
            </p>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-input type="text" size="mini" v-model="product_filter.keyword" style="width: 300px"
                      :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change">
          <el-table-column width="40px" fixed="left">
            <template slot="header" slot-scope="scope">
              <el-checkbox size="mini" :indeterminate="indeterminate" v-model="is_selected_all" @change="m__select_all"
                           :disabled="product_selected_list.length + c__product_display_list.filter(i => i.selected).length >= 10"></el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.selected" @change="m__indeterminate"
                           :disabled="product_selected_list.length + c__product_display_list.filter(i => i.selected).length >= 10"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" show-tooltip-when-overflow width="420px">
            <template slot-scope="scope">
              <div style="display: flex; gap: 5px; padding-right: 10px; overflow: hidden;">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                     style="width:50px; height: 50px;"> &nbsp;&nbsp;&nbsp;
                <div>
                  <a href="javascript:void(0)"
                     @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.itemid}`, shop)">
                    {{ scope.row.name }}
                  </a>
                  <br>
                  {{ $t('product.id') }}: {{ scope.row.itemid }}
                  <template>
                    &nbsp;
                    {{ $t('base.rating') }}: {{ scope.row.rating }}
                  </template>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.price | currency }} {{ m__currency() }}</template>
          </el-table-column>
          <el-table-column :label="$t('center.add_to_cart_units_30_days')" prop="add_to_cart_units" width="160px"
                           sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('center.items_sold_30_days')" prop="orders" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.orders | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('center.sales_30_days')" prop="sales" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.sales | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="130px" sortable="custom">
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                       layout="prev, pager, next, total" :total="c__product_filter_list.length"/>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-checkbox size="mini" v-model="product_filter.available">{{ $t('flash_sale.show_not_created_only') }}
            </el-checkbox>
          </el-col>
          <el-col :sm="12" class="text-right">
            <small>{{ $t('base.selected') }} <span
              style="color: orangered">{{ product_list.filter(i => i.selected).length }}</span> /
              <span
                style="color: orangered">{{ product_list.length }}</span> {{ $t('base.products') }}</small>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_select_product"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_dialog.select_product_suggest"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-row type="margin-top: 10px">
          <el-col :sm="12">
            <p v-if="loading_get_products"><span class="el-icon-loading"></span>
              <strong style="font-size: 18px" class="text-danger">
                {{ $t('base.loading_products') }}</strong></p>
            <p v-else><strong style="font-size: 18px">{{ $t('base.add_recommend_products') }}</strong></p>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-input type="text" size="mini" v-model="product_filter.keyword" style="width: 300px"
                      :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change">
          <el-table-column width="40px" fixed="left">
            <template slot="header" slot-scope="scope">
              <el-checkbox size="mini" :indeterminate="indeterminate" v-model="is_selected_all" @change="m__select_all"
                           :disabled="product_selected_list.length + c__product_display_list.filter(i => i.selected).length >= 10"></el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.selected" @change="m__indeterminate"
                           :disabled="product_selected_list.length + c__product_display_list.filter(i => i.selected).length >= 10"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" show-tooltip-when-overflow width="420px">
            <template slot-scope="scope">
              <div style="display: flex; gap: 5px; padding-right: 10px; overflow: hidden;">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                     style="width:50px; height: 50px;"> &nbsp;&nbsp;&nbsp;
                <div>
                  <a href="javascript:void(0)"
                     @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.itemid}`, shop)">
                    {{ scope.row.name }}
                  </a>
                  <br>
                  {{ $t('product.id') }}: {{ scope.row.itemid }}
                  <template>
                    &nbsp;
                    {{ $t('base.rating') }}: {{ scope.row.rating }}
                  </template>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.price | currency }} {{ m__currency() }}</template>
          </el-table-column>
          <el-table-column :label="$t('center.add_to_cart_units_30_days')" prop="add_to_cart_units" width="160px"
                           sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('center.items_sold_30_days')" prop="orders" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.orders | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('center.sales_30_days')" prop="sales" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.sales | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="130px" sortable="custom">
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                       layout="prev, pager, next, total" :total="c__product_filter_list.length"/>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-checkbox size="mini" v-model="product_filter.available">{{ $t('flash_sale.show_not_created_only') }}
            </el-checkbox>
          </el-col>
          <el-col :sm="12" class="text-right">
            <small>{{ $t('base.selected') }} <span
              style="color: orangered">{{ product_list.filter(i => i.selected).length }}</span> /
              <span
                style="color: orangered">{{ product_list.length }}</span> {{ $t('base.products') }}</small>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_select_product"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog width="600px" :close-on-click-modal="false" :visible.sync="show_dialog.time_slot"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <br>
        <p><strong style="font-size: 18px">{{ $t('base.selected_time_slots_list') }}</strong></p>

        <br>
        <p v-for="item in time_slots" style="font-size: 13px !important;">
          {{ m__get_time_slot_value(item.start_time, item.end_time) }}
        </p>
      </div>
    </el-dialog>

    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_dialog.create_flash_sale_file"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <br>
        <el-row type="margin-top: 30px">
          <el-col :sm="12">
            <p v-if="loading_get_products"><span class="el-icon-loading"></span>
              <strong style="font-size: 18px" class="text-danger">
                {{ $t('base.loading_products') }}</strong></p>
            <p v-else><strong style="font-size: 18px">{{ $t('select.products') }}
              <a href="javascript:void(0)" style="font-size: 14px" @click="m__get_product">
                ({{ $t('base.update_data') }})
              </a></strong>
            </p>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-input type="text" size="mini" v-model="product_filter.keyword" style="width: 300px"
                      :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change">
          <el-table-column width="40px" fixed="left">
            <template slot="header" slot-scope="scope">
              <el-checkbox size="mini" :indeterminate="indeterminate" v-model="is_selected_all" @change="m__select_all"
                           :disabled="product_selected_list.length + c__product_display_list.filter(i => i.selected).length >= 10"></el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.selected" @change="m__indeterminate"
                           :disabled="product_selected_list.length + c__product_display_list.filter(i => i.selected).length >= 10"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <div style="display: flex; gap: 5px">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                     style="width:50px; height: 50px;"> &nbsp;&nbsp;&nbsp;
                <div>
                  <a href="javascript:void(0)"
                     @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.itemid}`, shop)">
                    {{ scope.row.name }}
                  </a>
                  <br>
                  {{ $t('product.id') }}: {{ scope.row.itemid }}
                  <template>
                    &nbsp;
                    {{ $t('base.rating') }}: {{ scope.row.rating }}
                  </template>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.sold')" prop="sold" width="130px" sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.price | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.revenue | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="130px" sortable="custom">
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                       layout="prev, pager, next, total" :total="c__product_filter_list.length"/>

        <el-row style="margin-top: 15px">
          <el-col :sm="12">
            <el-checkbox size="mini" v-model="product_filter.available">{{
                $t('base.show_eligible_products_only')
              }}
            </el-checkbox>
          </el-col>
          <el-col :sm="12" class="text-right">
            <small>{{ $t('base.selected') }} <span
              style="color: orangered">{{ product_list.filter(i => i.selected).length }}</span> /
              <span
                style="color: orangered">{{ product_list.length }}</span> {{ $t('base.products') }}</small>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button v-if="select_product_type === 'create_fs_file'" size="mini" type="primary" icon="el-icon-check"
                       @click="m__show_create_flash_sale_filename_dialog"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
            <el-button v-if="select_product_type === 'add_to_fs_file'" size="mini" type="primary" icon="el-icon-check"
                       @click="m__add_product_to_flash_sale"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
            <el-button v-if="select_product_type === 'export_product'" size="mini" type="primary" icon="el-icon-check"
                       @click="m__export_product_file"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.create_flash_sale_filename"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filename') }}</p>
        <el-input v-model="filename" size="mini" :placeholder="$t('input.filename')"></el-input>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="primary" @click="m__create_flash_sale_file"
                     :loading="loading.create_flash_sale_file"> {{ $t('flash_sale.save_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_dialog.flash_sale_files"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-col :sm="12">
          <strong style="font-size: 14px">{{ $t('flash_sale.saved_file') }}</strong> &nbsp;&nbsp;
        </el-col>
        <el-col :sm="12" class="text-right">
          <el-input size="mini" :placeholder="$t('flash_sale.search_placeholder')" style="max-width: 250px;"
                    prefix-icon="el-icon-search" v-model="input_keyword" clearable/>
        </el-col>
        <br>
        <br>
        <el-table :data="c__flash_sale_files_filter_list">
          <el-table-column :label="$t('base.filename')" prop="filename">
            <template slot-scope="scope">
              {{ scope.row.filename }} <br>
              <span style="font-size: 11px; font-weight: 600">ID: {{ scope.row.id }}</span> <br>
              <span v-if="scope.row.auto" class="text-running">
                <a href="javascript:void(0)">{{ $t('flash_sale.auto_config_message_2') }}</a>
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.created_at')" prop="createdAt">
            <template slot-scope="scope">{{ scope.row.createdAt | moment('DD-MM-YYYY HH:mm') }}</template>
          </el-table-column>
          <el-table-column :label="$t('flash_sale.no_of_product')" width="120px">
            <template slot-scope="scope">{{ scope.row.products.length }}</template>
          </el-table-column>
          <el-table-column :label="$t('base.shop')">
            <template slot-scope="scope">
              <template v-if="scope.row.shopId">
                <a href="javascript:void(0)" @click="m__show_select_shop_dialog(scope.row)">
                  <strong class="text-warning">{{ m__get_shop_name(scope.row) }}</strong>
                </a>
              </template>
              <template v-else>
                <el-button type="text" size="mini" @click="m__show_select_shop_dialog(scope.row)">
                  <strong class="text-primary">{{ $t('select.shop') }}</strong></el-button>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.optional')" width="140px">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="m__use_flash_sale_file(scope.row)">
                <strong class="text-success">{{ $t('base.use_file') }}</strong>
              </el-button>
              <br>
              <el-button size="mini" type="text"
                         @click="m__show_select_product_from_flash_sale_files_dialog(scope.row)">
                <strong class="text-success">{{ $t('base.select_products') }}</strong>
              </el-button>
              <br>
              <el-button size="mini" type="text" @click="m__copy_flash_sale_price_from_file(scope.row)">
                <strong class="text-success">{{ $t('base.copy_price') }}</strong>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.action')">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="m__show_flash_sale_file_products(scope.row)">
                <strong class="text-warning">{{ $t('base.update_file') }}</strong></el-button>
              <el-button size="mini" type="text" @click="m__delete_flash_sale_file(scope.row)">
                <strong class="text-danger">Xóa file</strong></el-button>
              <div style="height: 5px"></div>
              <el-button size="mini" type="text" @click="m__show_clone_flash_sale_dialog(scope.row)"
                         :loading="loading.get_products">
                <strong class="text-warning">{{ $t('base.clone_file') }}</strong></el-button>
              <div style="height: 5px"></div>
              <el-button type="text" size="mini" @click="m__show_update_auto(scope.row)">
                <strong class="text-primary">{{ $t('flash_sale.setup_auto_config') }}</strong>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog id="show_flash_sale_file_products" width="1280px" :close-on-click-modal="false"
               :visible.sync="show_dialog.show_flash_sale_file_products" custom-class="no-body">
      <div slot="title" style="padding:10px">
        <div style="display: flex; align-items: center; margin-bottom: 20px">
          <div style="flex: 0 1 auto">
            <div>
              <strong class="strong-label">{{ $t('base.filename') }}</strong>
              <el-input size="mini" v-model="selected_file_update.filename" style="width: 280px"></el-input>
              &nbsp;&nbsp;
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="m__update_flash_sale_filename">
                {{ $t('base.edit_filename') }}
              </el-button>
              <el-button size="mini" type="primary" icon="el-icon-plus"
                         @click="m__show_add_product_to_flash_sale_file_dialog">
                {{ $t('base.add_products') }}
              </el-button>
              <el-button size="mini" type="primary" icon="el-icon-upload"
                         @click="m__show_import_product_dialog('flash_sale_file')">
                {{ $t('base.import_products') }}
              </el-button>
              <el-button type="info" size="mini" icon="el-icon-sort"
                         @click="m__show_change_product_position_dialog('flash_sale_file_product_list')">
                {{ $t('flash_sale.change_product_position') }}
              </el-button>
            </div>
          </div>
          <div style="flex: 1; text-align: right">
            <strong class="strong-label">&nbsp;</strong>
            <el-button type="primary" size="mini" icon="el-icon-check" @click="m__update_discount_flash_sale_file"
                       :loading="loading.update_discount">{{ $t('flash_sale.update_file') }}
            </el-button>
          </div>
        </div>

        <div>
          <strong class="text-danger">
            * {{ $t('flash_sale.setup_products_note') }}
          </strong>
        </div>

        <Component_FlashSaleProduct
          :id="'file-sticky'"
          style="margin-top: 10px"
          :seller="seller"
          :product_selected_list.sync="flash_sale_file_product_list"
          :flash_sale_created="[]"
          :shop_id="shop_id"
          :save_current_product="false"
          :show_enable="false"
          :parent_scroll_id="'#show_flash_sale_file_products > div'"
          :shop="shop"
          @m__remove_product="m__remove_flash_sale_file_product">
        </Component_FlashSaleProduct>

        <div style="margin-top: 20px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__update_discount_flash_sale_file"
                     :loading="loading.update_discount">{{ $t('flash_sale.update_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.update_auto"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong class="text-danger">
          - {{ $t('flash_sale.system_will_create_before_x_hours', {x: form_auto.pre_hour}) }}
        </strong>
        <br>
        <br>
        <br>

        <strong class="strong-label">{{
            $t('flash_sale.create_before_x_hours', {
              x: form_auto.pre_hour,
              min: 1,
              max: 20
            })
          }}
        </strong>
        <el-input size="mini" v-model="form_auto.pre_hour" type="number" :min="1" :max="20"></el-input>

        <br>
        <br>
        <strong class="strong-label">{{ $t('flash_sale.creation_time_slot') }}</strong>
        <el-time-select
          class="full-w"
          v-model="form_auto.time"
          size="mini"
          :picker-options="{start: '00:00',step: '00:30',end: '24:00'}"
          :placeholder="`${$t('base.select')} ${$t('flash_sale.creation_time_slot')}`">
        </el-time-select>

        <div class="text-right" style="margin-top: 20px">
          <el-button v-if="selected_file_update.auto" type="danger" size="mini" icon="el-icon-delete"
                     @click="m__delete_auto"> {{ $t('base.delete') }}
          </el-button>
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__update_auto"
                     :loading="loading.update_auto"> {{ $t('base.update') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="900px" :close-on-click-modal="false"
               :visible.sync="show_dialog.import_product_file"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <div style="margin-top: 30px">
          <p class="text-title">{{ $t('flash_sale.download_template_file') }}</p>

          <div style="margin-top: 20px">
            <el-radio v-model="export_product_file_type" label="all">{{ $t('product.all') }}</el-radio>
            <el-radio v-model="export_product_file_type" label="multiple">{{ $t('product.select_multiple') }}</el-radio>
            <el-radio v-model="export_product_file_type" label="current">{{ $t('product.current_list') }}</el-radio>
            <el-button type="primary" size="mini" icon="el-icon-download"
                       :loading="loading.export_product_file" @click="m__show_export_product_dialog">
              {{ $t('flash_sale.download_products_file') }}
            </el-button>
          </div>
        </div>


        <div style="margin-top: 60px; display: flex">
          <div style="flex: 0 1 auto; max-width: 360px">
            <p class="text-title">{{ $t('flash_sale.import_products') }}</p>

            <el-upload
              style="margin-top: 20px"
              class="upload-demo"
              drag
              action="#"
              :http-request="m__import_product_file">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                {{ $t('flash_sale.drag_and_drop_or') }}
                <em>{{ $t('flash_sale.click_to_upload') }}</em>
              </div>
              <div class="el-upload__tip" slot="tip">{{ $t('flash_sale.file_format_required') }}</div>
            </el-upload>
          </div>
          <div style="flex: 1; padding-left: 30px">
            <p class="text-title">{{ $t('base.example') }}</p>

            <div style="margin-top: 20px; font-size: 13px">
              - {{ $t('flash_sale.excel_code_title') }}:
              <div style="margin-top: 10px">
                <pre>{{ $t('flash_sale.excel_code') }}</pre>
              </div>
            </div>
            <div style="margin-top: 20px; font-size: 13px">
              - {{ $t('flash_sale.excel_code_title_2') }}:
              <div style="margin-top: 10px">
                <pre>{{ $t('flash_sale.excel_code_2') }}</pre>
              </div>
            </div>
          </div>
        </div>

        <div v-if="import_product_result_list.length" style="margin-top: 60px">
          <p class="text-title">{{ $t('base.result') }} {{ $t('flash_sale.import_products') }}</p>

          <div style="margin-top: 20px">
            <strong style="font-size: 13px"
                    :class="import_product_result_list.filter(i => !i[i.length - 1]).length === import_product_result_list.length ? 'text-success' : 'text-warning'">
              {{ $t('base.there_are') }} {{
                import_product_result_list.filter(i => !i[i.length - 1]).length
              }}/{{ import_product_result_list.length }}
              {{ $t('flash_sale.variations_uploaded') }}.
            </strong>
          </div>
          <div style="margin-top: 20px">
            <div v-for="item in import_product_result_list.filter(i => i[i.length - 1])" style="font-size: 13px">
              {{ item[item.length - 1] }}
            </div>
          </div>
        </div>

        <div v-if="import_product_result_list.filter(i => !i[i.length - 1]).length" style="margin-top: 60px"
             class="text-center">
          <el-button v-if="import_product_file_type === 'flash_sale'" type="primary" size="mini" icon="el-icon-plus"
                     @click="m__add_import_product_result_to_fs">
            {{ $t('base.add_products') }}
          </el-button>
          <el-button v-if="import_product_file_type === 'flash_sale_file'" type="primary" size="mini"
                     icon="el-icon-plus" @click="m__add_import_product_result_to_fs_file">
            {{ $t('flash_sale.add_products_to_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog id="select_product_from_flash_sale_files" width="1280px" :close-on-click-modal="false"
               :visible.sync="show_dialog.select_product_from_flash_sale_files"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.select_products') }}</strong>

        <Component_FlashSaleProduct
          :id="'file-sticky'"
          style="margin-top: 10px"
          :seller="seller"
          :product_selected_list.sync="flash_sale_file_product_list"
          :flash_sale_created="[]"
          :shop_id="shop_id"
          :save_current_product="false"
          :show_enable="false"
          :just_select_product="true"
          :parent_scroll_id="'#select_product_from_flash_sale_files > div'"
          :shop="shop"
          @m__remove_product="m__remove_flash_sale_file_product">
        </Component_FlashSaleProduct>

        <div style="margin-top: 20px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check"
                     @click="m__confirm_select_product_from_flash_sale_files">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.clone_flash_sale_file"
               custom-class="no-body">
      <div slot="title" style="padding: 20px">
        <p class="text-title"> {{ $t('flash_sale.filename') }}</p>
        <el-input v-model="filename" size="mini" :placeholder="$t('input.filename')"></el-input>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="primary" @click="m__clone_flash_sale_file" icon="el-icon-check"
                     :loading="loading.clone_flash_sale_file">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog id="select_product_from_flash_sale_files" width="600px" :close-on-click-modal="false"
               :visible.sync="show_dialog.change_product_position"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('flash_sale.change_product_position') }}</strong>

        <!--        <div style="margin-top: 30px; padding-right: 20px">
                  <div style="display: flex; flex-direction: column; gap: 20px">
                    <div v-for="(product, index) in change_product_position_list">
                      <div style="display: flex; align-items: center">
                        <div style="width: 35px; height: 35px">
                          <img :src="SHOPEE_IMAGE(product.images.split(',')[0])" alt="logo"
                               style="width:30px; height: 30px;"> &nbsp;&nbsp;&nbsp;
                        </div>
                        <div style="flex: 1; padding: 0 10px">
                          <div style="overflow: hidden">{{ product.name }}</div>
                          <div>SKU: {{ product.sku }} - ID: {{ product.itemid }}</div>
                        </div>
                        <div style="width: 30px">
                          <div style="width: 45px; height: 29px; display: flex; flex-direction: column">
                            <span role="button" @click="m__swap_product(index, 'up')"
                                  style="width: 100%; height: 14px; border: 1px solid gray; text-align: center; border-radius: 4px 4px 0 0; display: flex; align-items: center; justify-content: center; background: #fff; cursor: pointer">
                              <i class="el-icon-arrow-up" style="font-size: 11px"></i>
                            </span>
                            <span role="button" @click="m__swap_product(index, 'down')"
                                  style="width: 100%; height: 14px; text-align: center; border-radius: 0 0 4px 4px; border: 1px solid gray; border-top: 0; display: flex; align-items: center; justify-content: center; background: #fff; cursor: pointer">
                              <i class="el-icon-arrow-down" style="font-size: 11px"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>-->

        <div style="margin-top: 30px; padding-right: 20px">
          <draggable v-model="change_product_position_list" v-bind="dragOptions">
            <transition-group style="display: flex; flex-direction: column; gap: 5px">
              <div v-for="product in change_product_position_list" :key="product.itemid"
                   style="background-color: #fff; cursor: pointer; padding: 10px 5px">
                <div style="display: flex; align-items: center">
                  <div style="width: 35px; height: 35px">
                    <img :src="SHOPEE_IMAGE(product.images.split(',')[0])" alt="logo"
                         style="width:30px; height: 30px;"> &nbsp;&nbsp;&nbsp;
                  </div>
                  <div style="flex: 1; padding: 0 10px">
                    <div style="overflow: hidden">{{ product.name }}</div>
                    <div>SKU: {{ product.sku }} - ID: {{ product.itemid }}</div>
                  </div>
                  <div style="width: 30px">
                    <i class="el-icon-rank" style="font-size: 16px"></i>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>

        <div style="margin-top: 40px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.change_product_position"
                     @click="m__confirm_change_product_position()">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {drop as _drop, orderBy as _orderBy, take as _take, shuffle as _shuffle} from 'lodash'
import Component_FlashSaleProduct from './component_product'
import readXlsxFile from 'read-excel-file'
import {fix_ads_mixins} from "../../mixins/fix_ads";
import draggable from 'vuedraggable'

export default {
  name: 'page__flash_sale_edit',

  mixins: [fix_ads_mixins],

  components: {
    Component_FlashSaleProduct,
    draggable
  },

  props: {
    shop: null,
    shops: null,
    shop_id: null,
    shopee_id: null,
    seller: null,
    time_slots: null,
    flash_sale_created: null,
    flash_sale: null,
    loading_get_products: {
      type: Boolean,
      default: false
    },
    product_list: {
      type: Array,
      default: []
    },
    item_stock_price_infos: {
      type: Array,
      default: []
    },
    model_list: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      selected_shop_id: '',
      selected_shop_update: '',
      selected_file_update: {},
      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        available: false
      },
      indeterminate: false,
      is_selected_all: false,
      loading: {
        get_product: false,
        save_and_apply: false,
        create_flash_sale_file: false,
        select_shop: false,
        update_auto: false,
        update_discount: false,
        get_data: false,
        export_product_file: false,
        import_product_file: false,
        clone_flash_sale_file: false,
        change_product_position: false
      },
      show_dialog: {
        select_product: false,
        select_product_suggest: false,
        time_slot: false,
        create_flash_sale_file: false,
        create_flash_sale_filename: false,
        flash_sale_files: false,
        flash_sale_file_detail: false,
        show_flash_sale_file_products: false,
        select_shop: false,
        update_auto: false,
        export_product_file: false,
        import_product_file: false,
        select_product_from_flash_sale_files: false,
        clone_flash_sale_file: false,
        change_product_position: false
      },
      product_selected_list: [],
      model_is_select_all: false,
      save_and_apply_successfully: false,
      form_update: {
        discount_value: null,
        discount_type: 'percent',
        discount_percent: null,
        quantity: null,
        limit: 0,
        limit_value: null
      },
      item_ids: [],
      batch_items: [],
      filename: '',
      flash_sale_files: [],
      sticky_block: null,
      sticky_block_offset: null,
      flash_sale_file_product_list: [],
      form_auto: {
        time: '',
        pre_hour: 6
      },
      product_sort_option: {
        order: null,
        prop: null
      },

      input_keyword: '',

      product_suggest_list: [],

      select_product_type: 'create_fs_file',

      export_product_file_type: 'all',
      import_product_result_list: [],
      import_product_file_type: 'flash_sale',

      change_product_position_source_key: null,
      change_product_position_list: []
    }
  },

  async beforeMount() {
    console.log(this.flash_sale)

    this.loading.get_data = true

    while (this.loading_get_products) {
      await this.sleep(1000)
    }

    await this.m__get_flash_sale_files()
    await this.m__get_shop_flash_sale_items()

    for (const product of this.product_list) {
      product.checked = false
      product.selected = false
    }
    this.loading.get_data = false

    this.m__generate_product_suggest_list().catch(console.error)
  },

  watch: {
    // 'form_auto.pre_hour': function (){
    // this.form_auto.pre_hour < 4 && (this.form_auto.pre_hour = 4)
    // this.form_auto.pre_hour > 20 && (this.form_auto.pre_hour = 20)
    // }
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },

    c__product_filter_list() {
      let result = this.show_dialog.select_product_suggest
        ? this.product_suggest_list
        : this.product_list

      if (this.product_filter.available) {
        // result = result.filter(i => i.stock > 0)
        result = result.filter(i => !i.created)
      }

      if (!this.show_dialog.create_flash_sale_file) {
        result = result.filter(i => !this.product_selected_list.find(ii => ii.product.itemid === i.itemid))
      }

      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      // const words = this.remove_unicode(this.product_filter.keyword)
      // return result.filter(item => this.remove_unicode(JSON.stringify({
      //   id: item.itemid,
      //   name: item.name
      // })).includes(words))

      const words = this.remove_unicode(this.product_filter.keyword).split(',')
      const pattern = words.map(w => this.escape_regex(w)).join('|');
      const regex = new RegExp(pattern);

      return result.filter(item => {
        const string = this.remove_unicode(JSON.stringify({
          id: item.itemid,
          name: item.name,
          sku: item
        }))
        return regex.test(string)
      })
    },

    c__product_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)
      return _take(_drop(this.c__product_filter_list, skip), limit)
    },

    c__flash_sale_files_filter_list() {
      return this.flash_sale_files
        .filter(i => i.shopId === this.shop._id)
        .filter(i => this.remove_unicode(JSON.stringify(i)).includes(this.remove_unicode(this.input_keyword)))
    }
  },

  methods: {
    m__swap_product(index, type) {
      if (type === 'up') {
        if (index === 0) return
        const temp = this.change_product_position_list[index]
        this.change_product_position_list[index] = this.change_product_position_list[index - 1]
        this.change_product_position_list[index - 1] = temp
      } else {
        if (index === this.change_product_position_list.length - 1) return
        const temp = this.change_product_position_list[index]
        this.change_product_position_list[index] = this.change_product_position_list[index + 1]
        this.change_product_position_list[index + 1] = temp
      }

      this.change_product_position_list = this.clone(this.change_product_position_list)
    },

    async m__confirm_change_product_position() {
      try {
        await this.$confirm(this.$t('base.update_data_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.change_product_position = true

      const sorted_product_ids = this.change_product_position_list.map(i => i.itemid)
      this[this.change_product_position_source_key] = this[this.change_product_position_source_key].sort((a, b) => sorted_product_ids.indexOf(a.product.itemid) - sorted_product_ids.indexOf(b.product.itemid))

      // todo: testable
      if (this.change_product_position_source_key === 'product_selected_list') {
        const display_sequence_list = []
        for (let i = 0; i < this.product_selected_list.length; i++) {
          display_sequence_list.push({
            item_id: this.product_selected_list[i].product.itemid,
            display_sequence: this.product_selected_list.length - i
          })
        }
        await this.seller.flash_sale_set_item_sequence({
          flash_sale_id: this.flash_sale.flash_sale_id,
          display_sequence_list: display_sequence_list
        })
      }

      this.loading.change_product_position = false
      this.show_dialog.change_product_position = false
    },

    m__show_change_product_position_dialog(source_key) {
      if (!this[source_key]) return

      this.change_product_position_source_key = source_key
      this.change_product_position_list = this[source_key].map(i => i.product)
      this.show_dialog.change_product_position = true
    },

    async m__update_models_stock() {
      const item_id = this.product_selected_list.map(i => i.product.itemid.toString())
      const products_detail_response = await this.seller.get_product_by_graphql(item_id)
      if (products_detail_response && products_detail_response.data && products_detail_response.data.products.items &&
        products_detail_response.data.products.items && products_detail_response.data.products.items.length) {
        for (const product of this.product_selected_list) {
          const product_detail = products_detail_response.data.products.items.find(i => +i.itemid === +product.product.itemid)
          if (product_detail) {
            for (const model of product.model_list) {
              const model_detail = product_detail.modelList.find(i => +i.modelid === +model.modelid)
              if (model_detail) {
                model.stock = +model_detail.normalStock
                if (model.quantity > model.stock) model.quantity = model.stock
              }
            }
          }
        }
      }
    },

    m__copy_flash_sale_price_from_file(file) {
      for (const product of this.product_selected_list) {
        const product_in_file = file.products.find(i => i.productId === product.product.itemid)
        if (product_in_file && product_in_file.models) {
          const product_in_file_models = JSON.parse(product_in_file.models)
          for (const model of product.model_list) {
            const model_in_file = product_in_file_models.find(i => i.modelid === model.modelid)
            if (model_in_file) {
              model.discount_price = model_in_file.discount_price
              model.discount_percent = model_in_file.discount_percent
              model.quantity = model_in_file.quantity
            }
          }
        }
      }

      this.show_dialog.flash_sale_files = false
    },

    async m__clone_flash_sale_file() {
      if (!this.filename) {
        this.ntf_w(this.$t('required.filename'))
        return
      }

      this.loading.clone_flash_sale_file = true
      try {
        const form = {
          mipeeUserId: this.$store.state.userInfo.username,
          filename: this.filename,
          products: this.selected_file_update.products,
          shopId: this.shop._id,
          shopeeId: this.shop.shop_id
        }
        await this.$http.post(this.API.URL_API_SRV_1 + '/flash_sale', form, this.cf())
        await this.m__get_flash_sale_files()
        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.clone_flash_sale_file = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.clone_flash_sale_file = false
      }
    },

    m__show_clone_flash_sale_dialog(file) {
      this.filename = ''
      this.selected_file_update = file
      this.show_dialog.clone_flash_sale_file = true
    },

    m__confirm_select_product_from_flash_sale_files() {
      for (const product of this.flash_sale_file_product_list.filter(i => i.checked)) {
        if (this.product_selected_list.length === 10) {
          this.show_dialog.flash_sale_files = false
          return
        }

        const product_found = this.product_list.find(i => i.itemid === product.product.itemid)
        if (product_found && !this.product_selected_list.some(i => i.product.itemid === product.product.itemid)) {
          for (const model of product.model_list) {
            model.checked = false
          }
          this.product_selected_list.push({
            ...product,
            checked: false
          })
        }
      }
      this.show_dialog.select_product_from_flash_sale_files = false
      this.show_dialog.flash_sale_files = false
      this.m__update_models_stock().catch(console.error)
    },

    m__show_select_product_from_flash_sale_files_dialog(file) {
      this.flash_sale_file_product_list = this.product_list.reduce((result, product) => {
        const product_found = file.products.find(i => i.productId === product.itemid)
        if (product_found) {
          const row = {
            product: product,
            model_list: product_found.models
              ? JSON.parse(product_found.models).map(model => {
                const model_found = this.clone(this.model_list[product.itemid]).find(i => i.modelid === model.modelid)
                if (model_found) {
                  model.name = model.name || ''
                  model.price = model_found.price
                  model.stock = model_found.stock
                }
                return model
              })
              : this.clone(this.model_list[product.itemid])
          }
          result.push(row)
        }
        return result
      }, [])

      const product_ids = file.products.map(i => i.productId)
      this.flash_sale_file_product_list = this.flash_sale_file_product_list.sort((a, b) => product_ids.indexOf(a.product.itemid) - product_ids.indexOf(b.product.itemid))

      this.show_dialog.select_product_from_flash_sale_files = true
    },

    m__add_import_product_result_to_fs() {
      for (const item of this.import_product_result_list) {

        const product = this.product_list.find(i => i.itemid === +item[0])
        if (!product) continue
        // console.log('product', product)

        const model = this.model_list[product.itemid].find(i => i.modelid === +item[2])
        if (!model) continue
        // console.log('model', model)

        const product_found = this.product_selected_list.find(i => i.product.itemid === +item[0])
        if (product_found) {
          const model_found = product_found.model_list.find(i => i.modelid === +item[2])
          if (model_found) {
            model_found.discount_price = this.m__calculate(item[7])
            model_found.discount_percent = this.m__calculate(100 - (model_found.discount_price * 100 / model_found.price))
            model_found.quantity = +item[8]

            if (+item[9]) {
              product_found.product.limit = 1
              product_found.product.limit_value = +item[9]
              model_found.limit_value = +item[9]
            }
          }
        } else {
          const new_product = {
            checked: false,
            product: this.clone(product),
            model_list: this.clone(this.model_list[product.itemid])
          }
          const model_found = new_product.model_list.find(i => i.modelid === +item[2])
          if (model_found) {
            model_found.discount_price = this.m__calculate(item[7])
            model_found.discount_percent = this.m__calculate(100 - (model_found.discount_price * 100 / model.price))
            model_found.quantity = +item[8]

            if (+item[9]) {
              new_product.product.limit = 1
              new_product.product.limit_value = +item[9]
              model_found.limit_value = +item[9]
            }
          }

          if (this.product_selected_list.length < 10) {
            this.product_selected_list.push(new_product)
          }
        }
      }

      this.show_dialog.import_product_file = false
      this.m__update_models_stock().catch(console.error)
    },

    m__add_import_product_result_to_fs_file() {
      for (const item of this.import_product_result_list) {
        const product = this.product_list.find(i => i.itemid === +item[0])
        if (!product) continue
        console.log('product', product)

        const model = this.model_list[product.itemid].find(i => i.modelid === +item[2])
        if (!model) continue
        console.log('model', model)

        const product_in_file = this.selected_file_update.products.find(i => i.productId === +item[0])
        if (product_in_file) {
          console.log('product_in_file', product_in_file)
          let models_list
          if (product_in_file.models) {
            models_list = JSON.parse(product_in_file.models)
            const model_in_file = models_list.find(i => i.modelid === +item[2])
            if (model_in_file) {
              console.log('model_in_file', model_in_file)
              model_in_file.discount_price = +item[7]
              model_in_file.discount_percent = this.m__calculate(100 - (model_in_file.discount_price * 100 / model_in_file.price))
              model_in_file.quantity = +item[8]
            } else {
              console.log('model_in_file no')
              const model_template = this.clone(model)
              model_template.discount_price = +item[7]
              model_template.discount_percent = this.m__calculate(100 - (model_template.discount_price * 100 / model_template.price))
              model_template.quantity = +item[8]
              models_list.push(model_template)
            }
          } else {
            console.log('product_in_file no models')
            const model_template = this.clone(model)
            model_template.discount_price = +item[7]
            model_template.discount_percent = this.m__calculate(100 - (model_template.discount_price * 100 / model_template.price))
            model_template.quantity = +item[8]
            models_list = [model_template]
          }
          product_in_file.models = JSON.stringify(models_list)
        } else {
          console.log('product_in_file no')
          const model_template = this.clone(model)
          model_template.discount_price = +item[7]
          model_template.discount_percent = this.m__calculate(100 - (model_template.discount_price * 100 / model_template.price))
          model_template.quantity = +item[8]
          this.selected_file_update.products.push({
            productId: +item[0],
            models: JSON.stringify([model_template])
          })
        }
      }

      this.flash_sale_file_product_list = this.product_list.reduce((result, product) => {
        const product_found = this.selected_file_update.products.find(i => i.productId === product.itemid)
        if (product_found) {
          const row = {
            product: product,
            model_list: product_found.models
              ? JSON.parse(product_found.models).map(model => {
                const model_found = this.clone(this.model_list[product.itemid]).find(i => i.modelid === model.modelid)
                if (model_found) {
                  model.name = model.name || ''
                  model.price = model_found.price
                  model.stock = model_found.stock
                }
                return model
              })
              : this.clone(this.model_list[product.itemid])
          }
          result.push(row)
        }
        return result
      }, [])

      const product_ids = this.selected_file_update.products.map(i => i.productId)
      this.flash_sale_file_product_list = this.flash_sale_file_product_list.sort((a, b) => product_ids.indexOf(a.product.itemid) - product_ids.indexOf(b.product.itemid))

      this.show_dialog.import_product_file = false
    },

    async m__import_product_file(file) {
      this.import_product_result_list = []

      try {
        const raw = await readXlsxFile(file.file)
        for (const [index, row] of raw.entries()) {
          if (index === 0) continue

          const result = this.clone(row)

          if (!Number(row[7])) {
            result.push(`${this.$t('base.row')} ${index + 1}: ${this.$t('flash_sale.invalid_discount_price')}`)
          } else if (Number(row[6]) && !Number(row[8])) {
            result.push(`${this.$t('base.row')} ${index + 1}: ${this.$t('flash_sale.invalid_quantity')}`)
          } else {
            result.push('')
          }

          this.import_product_result_list.push(result)
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.cannot_import_file'))
      }
    },

    m__show_import_product_dialog(type) {
      this.import_product_file_type = type
      this.import_product_result_list = []
      this.show_dialog.import_product_file = true
    },

    async m__export_product_file() {
      const products = []
      if (this.export_product_file_type === 'all') products.push(...this.product_list)
      if (this.export_product_file_type === 'multiple') products.push(...this.product_list.filter(i => i.selected))
      if (this.export_product_file_type === 'current') {
        if (this.show_dialog.show_flash_sale_file_products) {
          products.push(...this.product_list.filter(i => this.flash_sale_file_product_list.find(ii => ii.product.itemid === i.itemid)))
        } else {
          products.push(...this.product_list.filter(i => this.product_selected_list.find(ii => ii.product.itemid === i.itemid)))
        }
      }

      if (!products.length) {
        this.ntf_w(this.$t('required.select_products'))
        return
      }

      this.loading.export_product_file = true
      const data = [[this.$t('product.id'), this.$t('product.name'), this.$t('product.model_id'), this.$t('product.model_name'), this.$t('product.original_price'), this.$t('product.current_price'), this.$t('product.stock'), `*${this.$t('product.flash_sale_price')}`, `*${this.$t('product.promotion_quantity')}`, `*${this.$t('product.limit')}`, this.$t('base.product_sku'), this.$t('base.model_sku')]]

      for (const product of products) {
        for (const model of this.model_list[product.itemid]) {
          const row = [product.itemid.toString(), product.name, model.modelid.toString(), model.name || '-', +model.price, +model.promotionPrice || +model.price, +model.stock, null, null, 0, product.sku || '-', model.sku || '-']
          data.push(row)
        }
      }

      const filename = `flash_sale-products-shop-${this.seller.username}-${this.dayjs().format('DDMMYYYY-HHmm')}.xlsx`
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        data: data,
        filename: filename
      }, {
        ...this.cf(),
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()

      this.ntf_s(this.$t('product.download_file_success'))
      this.loading.export_product_file = false
      this.show_dialog.create_flash_sale_file = false
    },

    m__show_export_product_dialog() {
      this.select_product_type = 'export_product'
      if (this.export_product_file_type === 'all') {
        this.m__export_product_file()
      }
      if (this.export_product_file_type === 'multiple') {
        this.show_dialog.select_product = true
      }
      if (this.export_product_file_type === 'current') {
        this.m__export_product_file()
      }
    },

    m__add_product_to_flash_sale() {
      this.flash_sale_file_product_list_save = this.product_list.filter(i => i.selected).map(i => ({product: i}))
      for (const product of this.flash_sale_file_product_list_save) {
        const found = this.selected_file_update.products.find(i => i.productId === product.product.itemid)
        if (found) continue

        this.selected_file_update.products.push({
          productId: product.product.itemid,
          models: JSON.stringify(product.model_list)
        })
      }

      this.flash_sale_file_product_list = this.product_list.reduce((result, product) => {
        const product_found = this.selected_file_update.products.find(i => i.productId === product.itemid)
        if (product_found) {
          const row = {
            product: product,
            model_list: product_found.models
              ? JSON.parse(product_found.models).map(model => {
                const model_found = this.clone(this.model_list[product.itemid]).find(i => i.modelid === model.modelid)
                if (model_found) {
                  model.name = model.name || ''
                  model.price = model_found.price
                  model.stock = model_found.stock
                }
                return model
              })
              : this.clone(this.model_list[product.itemid])
          }
          result.push(row)
        }
        return result
      }, [])

      const product_ids = this.selected_file_update.products.map(i => i.productId)
      this.flash_sale_file_product_list = this.flash_sale_file_product_list.sort((a, b) => product_ids.indexOf(a.product.itemid) - product_ids.indexOf(b.product.itemid))

      this.show_dialog.create_flash_sale_file = false
    },

    m__show_add_product_to_flash_sale_file_dialog() {
      this.select_product_type = 'add_to_fs_file'
      this.show_dialog.create_flash_sale_file = true
    },

    m__is_fs() {
      const agency = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.package && i.package.channel === 'shopee_marketing_fs')
      if (agency) {
        return this.dayjs().isBefore(this.dayjs(new Date(agency.license_to)), 's')
      } else {
        return false
      }
    },

    async m__generate_product_suggest_list() {
      while (this.loading_get_products) {
        await this.sleep(1000)
      }

      this.product_suggest_list = _take(_shuffle(_take(_orderBy(this.product_list, ['revenue'], ['desc']), 30)), 15)
    },

    async m__update_flash_sale_filename() {
      if (!this.selected_file_update || !this.selected_file_update.filename) {
        this.ntf_w(this.$t('required.filename'))
        return
      }

      try {
        await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale/filename', {
          ...this.selected_file_update
        }, this.cf())

        await this.m__get_flash_sale_files()

        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    m__get_shop_name(data) {
      if (this.shops && data.shopId) {
        const found = this.shops.find(i => i._id === data.shopId)
        return found ? found.username : ''
      }
      return ''
    },

    m__show_update_auto(item) {
      if (!item.shopId) {
        this.ntf_w(this.$t('required.shop'))
        return
      }

      if (item.auto) {
        this.form_auto.time = item.auto.time
        this.form_auto.pre_hour = item.auto.preHour || 6
      }

      this.selected_file_update = item
      this.show_dialog.update_auto = true
    },

    async m__update_auto() {
      if (!this.form_auto.pre_hour) {
        this.ntf_w(this.$t('required.full_data'))
        return
      }

      if (!this.form_auto.time) {
        this.ntf_w(this.$t('required.full_data'))
        return
      }

      this.loading.update_auto = true

      await this.$http.post(this.API.URL_API_SRV_1 + '/flash_sale/auto', {
        flashSaleFileId: this.selected_file_update.id,
        mipeeUserId: this.$store.state.userInfo.username,
        time: this.form_auto.time,
        preHour: this.form_auto.pre_hour
      }, this.cf())

      this.selected_file_update.auto = {
        time: this.form_auto.time,
        preHour: this.form_auto.pre_hour
      }
      this.ntf_s(this.$t('base.save_success'))

      this.loading.update_auto = false
      this.show_dialog.update_auto = false
    },

    async m__delete_auto() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/flash_sale/auto', {
          ...this.cf(),
          params: {
            flashSaleFileId: this.selected_file_update.id,
            mipeeUserId: this.$store.state.userInfo.username
          }
        })
        this.selected_file_update.auto = null
        this.ntf_s(this.$t('base.delete_success'))
        this.show_dialog.update_auto = false
      } catch (e) {

      }
    },

    m__show_select_shop_dialog(data) {
      this.selected_shop_update = data.shopId
      this.selected_file_update = data
      this.show_dialog.select_shop = true
    },

    async m__update_discount_flash_sale_file() {
      this.loading.update_discount = true

      this.selected_file_update.products = this.flash_sale_file_product_list.map(i => {
        return {
          productId: i.product.itemid,
          models: JSON.stringify(i.model_list)
        }
      })

      try {
        await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale', {
          ...this.selected_file_update
        }, this.cf())
        await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale/filename', {
          ...this.selected_file_update
        }, this.cf())

        await this.m__get_flash_sale_files()

        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.show_flash_sale_file_products = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.update_discount = false
      }
    },

    m__product_sort_change({
                             prop,
                             order
                           }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    },

    m__show_create_flash_sale_file_dialog() {
      this.select_product_type = 'create_fs_file'
      this.show_dialog.create_flash_sale_file = true
    },

    m__show_create_flash_sale_filename_dialog() {
      this.filename = ''
      this.show_dialog.create_flash_sale_filename = true
    },

    m__show_flash_sale_files_dialog() {
      this.show_dialog.flash_sale_files = true
    },

    async m__delete_flash_sale_file(item) {
      try {
        await this.$confirm(this.$t('flash_sale.delete_file_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/flash_sale', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            flashSaleFileId: item.id
          }
        })
        await this.m__get_flash_sale_files()
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
      }
    },

    m__use_flash_sale_file(file) {
      for (const product of file.products) {
        if (this.product_selected_list.length === 10) {
          this.show_dialog.flash_sale_files = false
          return
        }

        const product_found = this.product_list.find(i => i.itemid === product.productId)
        if (product_found && !this.product_selected_list.some(i => i.product.itemid === product.productId)) {
          this.product_selected_list.push({
            product: this.clone(product_found),
            model_list: product.models
              ? JSON.parse(product.models).map(model => {
                const model_found = this.clone(this.model_list[product_found.itemid]).find(i => i.modelid === model.modelid)
                if (model_found) {
                  model.name = model.name || ''
                  model.price = model_found.price
                  model.stock = model_found.stock
                }
                return model
              })
              : this.clone(this.model_list[product_found.itemid])
          })
        }
      }

      this.show_dialog.flash_sale_files = false
      this.m__update_models_stock().catch(console.error)
    },

    m__show_flash_sale_file_products(file) {
      if (!file.shopId) {
        this.ntf_w(this.$t('required.shop'))
        return
      }

      this.selected_file_update = file

      this.flash_sale_file_product_list = this.product_list.reduce((result, product) => {
        const product_found = file.products.find(i => i.productId === product.itemid)
        if (product_found) {
          const row = {
            product: product,
            model_list: product_found.models
              ? JSON.parse(product_found.models).map(model => {
                const model_found = this.clone(this.model_list[product.itemid]).find(i => i.modelid === model.modelid)
                if (model_found) {
                  model.name = model.name || ''
                  model.price = model_found.price
                  model.stock = model_found.stock
                }
                return model
              })
              : this.clone(this.model_list[product.itemid])
          }
          result.push(row)
        }
        return result
      }, [])

      const product_ids = file.products.map(i => i.productId)
      this.flash_sale_file_product_list = this.flash_sale_file_product_list.sort((a, b) => product_ids.indexOf(a.product.itemid) - product_ids.indexOf(b.product.itemid))

      this.show_dialog.show_flash_sale_file_products = true
    },

    async m__get_flash_sale_files() {
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/flash_sale', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          shopId: this.shop._id,
          shopeeId: this.shop.shop_id
        }
      })
      const resp_auto = await this.$http.get(this.API.URL_API_SRV_1 + '/flash_sale/auto', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          shopId: this.shop._id,
          shopeeId: this.shop.shop_id
        }
      })
      for (const item of resp.data) {
        item.auto = resp_auto.data.find(i => i.flashSaleFileId === item.id)
      }
      this.flash_sale_files = resp.data

      this.$emit('m__get_flash_sale_files')
    },

    async m__create_flash_sale_file() {
      if (!this.filename) {
        this.ntf_w(this.$t('required.filename'))
        return
      }
      if (!this.product_list.filter(i => i.selected).length) {
        this.ntf_w(this.$t('required.select_products'))
        return
      }

      const form = {
        mipeeUserId: this.$store.state.userInfo.username,
        filename: this.filename,
        products: this.product_list.filter(i => i.selected).map(i => ({productId: i.itemid})),
        shopId: this.shop._id,
        shopeeId: this.shop.shop_id
      }

      try {
        this.loading.create_flash_sale_file = true
        await this.$http.post(this.API.URL_API_SRV_1 + '/flash_sale', form, this.cf())
        await this.m__get_flash_sale_files()
        this.ntf_s(this.$t('base.save_success'))
        this.show_dialog.create_flash_sale_filename = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.create_flash_sale_file = false
      }
    },

    async m__get_item_ids() {
      if (!this.flash_sale) {
        return
      }

      this.item_ids = []
      const resp = await this.seller.flash_sale_get_item_ids(this.flash_sale.flash_sale_id)
      this.item_ids = resp.data.item_ids
    },

    async m__get_batch_items() {
      if (!this.flash_sale) {
        return
      }

      this.item_ids = []
      const items_ids = new Set()

      this.batch_items = []
      let offset = 0, limit = 100, count = 0
      let batch_resp = await this.seller.flash_sale_get_batch_items(this.flash_sale.flash_sale_id, offset, limit)

      while (batch_resp.data.items && batch_resp.data.items.length) {
        for (const item of batch_resp.data.items) {
          items_ids.add(item.item_id)

          const item_found = batch_resp.data.price_stock_info.find(i => i.item_id === item.item_id)
          const model_found = item_found.sku_stock_price_list.find(i => i.model_id === item.model_id)
          item.price = model_found.price_info.normal_price
          item.quantity = model_found.seller_stock_info.normal_stock
        }
        this.batch_items.push(...batch_resp.data.items)

        count += batch_resp.data.item_info.length
        if (count >= batch_resp.data.total_count) break

        offset += limit
        batch_resp = await this.seller.flash_sale_get_batch_items(this.flash_sale.flash_sale_id, offset, limit)
      }

      this.item_ids = Array.from(items_ids)
    },

    async m__get_shop_flash_sale_items() {
      // await this.m__get_item_ids()
      await this.m__get_batch_items()

      for (const item_id of this.item_ids) {
        const product = this.clone(this.product_list.find(i => i.itemid === item_id))
        if (product) {
          const batch_items = this.batch_items.filter(i => i.item_id === item_id)
          this.product_selected_list.push({
            product: product,
            model_list: this.clone(this.model_list[product.itemid]).map(i => {
              const batch = batch_items.find(ii => ii.model_id === i.modelid)
              if (batch) {
                product.limit = batch.purchase_limit > 0 ? 1 : 0
                product.limit_value = batch.purchase_limit
                i.stock = batch.quantity
                i.quantity = batch.stock
                i.discount_price = batch.promotion_price
                i.discount_percent = this.m__calculate(100 - (i.discount_price * 100 / i.price))
                i.enable = batch.status === 1
                i.message = ''
                i.error_message = ''
              }
              return i
            })
          })
        }
      }

      for (const item of this.product_selected_list) {
        const available_number = item.model_list.filter(i => i.quantity > 0).length
        const enable_number = item.model_list.filter(i => i.enable).length
        item.product.enable = available_number === enable_number
      }

      const item_list = []
      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          item_list.push({
            itemid: item.product.itemid,
            modelid: model.modelid
          })
        }
      }
      const flash_sale_get_misleading_discount = await this.seller.flash_sale_get_misleading_discount({item_list: item_list})
      if (flash_sale_get_misleading_discount && flash_sale_get_misleading_discount.data &&
        flash_sale_get_misleading_discount.data.misleading_item_list && flash_sale_get_misleading_discount.data.misleading_item_list.length) {
        for (const item of flash_sale_get_misleading_discount.data.misleading_item_list) {
          const product_found = this.product_selected_list.find(i => i.product.itemid === item.itemid)
          if (product_found) {
            const model_found = product_found.model_list.find(i => i.modelid === item.modelid)
            if (model_found) model_found.misleading = true
          }
        }
      }

      this.m__update_models_stock().catch(console.error)
    },

    m__can_update_multiple() {
      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          if (model.checked) {
            return false
          }
        }
      }
      return true
    },

    m__update_multiple(selected = false) {
      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          if (!selected && model.stock > 0 && !model.enable) {
            if (this.form_update.limit === 0 || (this.form_update.limit === 1 && this.form_update.limit_value)) {
              item.product.limit = this.form_update.limit
              item.product.limit_value = this.form_update.limit_value
            }

            if (this.form_update.discount_type === 'percent' && this.form_update.discount_value) {
              model.discount_percent = this.form_update.discount_value
              this.m__model_update_discount_percent(item, model)
            }
            if (this.form_update.discount_type === 'cash' && this.form_update.discount_value) {
              model.discount_price = this.form_update.discount_value
              this.m__model_update_discount_price(item, model)
            }

            if (this.form_update.quantity) {
              model.quantity = this.form_update.quantity
            }
          }

          if (selected && model.checked && model.stock > 0 && !model.enable) {
            if (this.form_update.limit && this.form_update.limit_value) {
              item.product.limit = this.form_update.limit
              item.product.limit_value = this.form_update.limit_value
            }

            if (this.form_update.discount_type === 'percent' && this.form_update.discount_value) {
              model.discount_percent = this.form_update.discount_value
              this.m__model_update_discount_percent(item, model)
            }
            if (this.form_update.discount_type === 'cash' && this.form_update.discount_value) {
              model.discount_price = this.form_update.discount_value
              this.m__model_update_discount_price(item, model)
            }

            if (this.form_update.quantity) {
              model.quantity = this.form_update.quantity
            }
          }
        }
      }
    },

    async m__enable_multiple() {
      if (this.loading.save_and_apply) return

      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          if (model.checked && model.stock > 0) {
            item.product.enable = true
            await this.m__product_enable_change(item, false, false)
          }
        }
      }
    },

    m__show_time_slot() {
      this.show_dialog.time_slot = true
    },

    m__get_time_slot_value(start_time, end_time) {
      return `${this.dayjs(start_time * 1000).format('DD-MM-YYYY')}: ${this.dayjs(start_time * 1000).format('HH:mm:ss')}-${this.dayjs(end_time * 1000).format('HH:mm:ss')}`
    },

    m__select_all() {
      this.indeterminate = false
      if (this.is_selected_all) {
        this.c__product_filter_list.forEach(i => {
          i.selected = true
        })
      } else {
        this.product_list.forEach(i => {
          i.selected = false
        })
      }
    },

    m__indeterminate() {
      if (this.product_list.filter(i => i.selected === true).length === this.product_list.length) {
        this.is_selected_all = true
        this.indeterminate = false
      } else if (this.product_list.filter(i => i.selected === true).length === 0) {
        this.is_selected_all = false
        this.indeterminate = false
      } else {
        this.is_selected_all = false
        this.indeterminate = true
      }
    },

    async m__back_to_list() {
      if (this.product_selected_list.length > 0) {
        this.$emit('m__back_to_list', true)
      } else {
        try {
          await this.$confirm(this.$t('flash_sale.back_to_list_message'), this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.exit')
          })
        } catch (e) {
          this.$emit('m__back_to_list', true)
        }
      }
    },

    m__get_product() {
      this.$emit('m__get_product')
    },

    m__show_select_product_suggest_dialog() {
      if (!this.c__product_filter_list.find(i => i.checked.length)) {
        this.indeterminate = false
      }
      this.show_dialog.select_product_suggest = true
    },

    m__show_select_product_dialog() {
      if (!this.c__product_filter_list.find(i => i.checked.length)) {
        this.indeterminate = false
      }
      this.show_dialog.select_product = true
    },

    m__confirm_select_product() {
      let product_filter = this.product_list.filter(i => i.selected)
      product_filter = product_filter.slice(0, 10)
      for (const product of product_filter) {
        this.product_selected_list.push({
          product: this.clone(product),
          model_list: this.clone(this.model_list[product.itemid])
        })
      }

      this.is_selected_all = false
      this.indeterminate = false
      this.product_list.forEach(i => i.selected = false)
      this.show_dialog.select_product = false
      this.show_dialog.select_product_suggest = false
      this.m__update_models_stock().catch(console.error)
    },

    m__model_select_all_change() {
      this.product_selected_list.forEach(i => {
        i.checked = this.model_is_select_all
        i.model_list.forEach(ii => ii.checked = this.model_is_select_all)
      })
    },

    m__check_product(product) {
      if (product.checked) {
        product.model_list.forEach(ii => ii.checked = true)
      } else {
        product.model_list.forEach(ii => ii.checked = false)
      }

      this.m__model_item_checked_change()
    },

    m__model_item_checked_change() {
      for (const item of this.product_selected_list) {
        const checked_number = item.model_list.reduce((total, model) => {
          if (model.checked) total++
          return total
        }, 0)
        item.checked = item.model_list.length === checked_number
      }

      const checked_number = this.product_selected_list.reduce((result, item) => {
        result[0] += item.model_list.length
        result[1] += item.model_list.filter(i => i.checked).length
        return result
      }, [0, 0])

      this.model_is_select_all = checked_number[0] === checked_number[1]
    },

    async m__product_enable_change(item, unchecked = true, submit = false) {
      if (this.loading.save_and_apply) return

      if (item.product.enable) {
        for (const i of item.model_list) {
          if (i.stock > 0) {
            i.enable = true
            await this.m__model_enable_change(item, i, unchecked, true)
          } else {
            i.enable = false
          }
        }
      } else {
        item.model_list.forEach(i => {
          i.enable = false
          i.stock += i.quantity
        })
      }

      if (unchecked) {
        this.model_is_select_all = false
        this.product_selected_list.forEach(i => i.model_list.forEach(ii => ii.checked = false))
      }

      if (submit) await this.m__save_and_apply()
    },

    async m__model_enable_change(item, model, unchecked = true, submit = false) {
      if (this.loading.save_and_apply) return

      if (!model.enable) {
        model.stock = Number(model.stock) + Number(model.quantity)
      }

      if (model.discount_percent > 90 || model.discount_percent < 5) {
        item.product.error_message = this.$t('flash_sale.discount_percent_between_x_y', {
          x: '5',
          y: '90'
        })
        model.enable = false
        item.product.enable = false
        return
      }

      if (model.quantity < 1 || model.quantity > model.stock) {
        item.product.error_message = this.$t('flash_sale.promotion_quantity_between_x_y', {
          x: '1',
          Y: model.stock
        })
        model.enable = false
        item.product.enable = false
        return
      }

      if (model.quantity * this.flash_sale_created.length > model.stock) {
        item.product.error_message = this.$t('flash_sale.evenly_every_days')
        model.enable = false
        item.product.enable = false
        return
      }

      const available_number = item.model_list.filter(i => i.stock > 0).length
      const enable_number = item.model_list.filter(i => i.enable).length
      item.product.enable = available_number === enable_number
      item.product.error_message = ''

      if (unchecked) {
        this.model_is_select_all = false
        this.product_selected_list.forEach(i => i.model_list.forEach(ii => ii.checked = false))
      }

      if (submit) await this.m__save_and_apply()

      if (model.enable) {
        model.stock = Number(model.stock) - Number(model.quantity)
      }
    },

    m__model_update_discount_price(item, model) {
      if (model.discount_price > model.price) {
        model.discount_price = model.price
      } else if (model.discount_price < 1000) {
        model.discount_price = 1000
      }

      model.discount_percent = this.m__calculate(100 - (model.discount_price * 100 / model.price))
      item.product.error_message = ''
    },

    m__model_update_discount_percent(item, model) {
      if (model.discount_percent > 100) {
        model.discount_percent = 100
      } else if (model.discount_percent < 0) {
        model.discount_percent = 0
      }

      model.discount_price = this.m__calculate(model.price - (model.price * model.discount_percent / 100))
      item.product.error_message = ''
    },

    async m__remove_product(item) {
      if (item) {
        try {
          await this.$confirm(this.$t('base.delete_product_confirm'), this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel')
          })
          this.product_selected_list = this.product_selected_list.filter(i => i.product.itemid !== item.product.itemid)
          await this.m__delete_item(item)
        } catch (e) {
        }
      } else {
        try {
          await this.$confirm(this.$t('base.delete_all_product_confirm'), this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel')
          })
          for (const item of this.product_selected_list) {
            await this.m__delete_item(item)
          }
          this.product_selected_list = []
        } catch (e) {
        }
      }
    },

    async m__save_and_apply(ntf = true) {
      let must_confirm = false
      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          model.error_message = ''

          if (!model.enable) continue

          if (+model.discount_percent >= 50) {
            model.error_message = this.$t('flash_sale.discount_percent_is_higher_x', {x: '50%'})
            must_confirm = true
          }
        }
      }
      if (must_confirm) {
        try {
          await this.$confirm(this.$t('flash_sale.discount_percent_is_higher_x_warning', {x: '50%'}), this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel')
          })
        } catch (e) {
          return
        }
      }

      let has_error = false
      this.loading.save_and_apply = true
      const form = {
        flash_sale_id: this.flash_sale.flash_sale_id,
        items: []
      }
      for (const item of this.product_selected_list) {
        // console.log('product', item.product)

        for (const model of item.model_list) {
          if (model.stock > 0) {
            form.items.push({
              item_id: item.product.itemid,
              model_id: model.modelid,
              input_promo_price: +model.discount_price,
              purchase_limit: item.product.limit === 1 && item.product.limit_value ? +item.product.limit_value : 0,
              status: model.enable ? 1 : 0,
              stock: +model.quantity,
              item_display_image: item.product.images.split(',')[0],
            })
          }
        }
      }

      // console.log(form)
      if (form.items.length) {
        const resp = await this.seller.flash_sale_save_batch_items(form)
        console.log(resp)
        if (resp.code !== 0) {
          has_error = true
          this.ntf_w(this.$t('flash_sale.create_error_message'))
        }

        if (resp && resp.data && resp.data.failed_items) {
          for (const item of resp.data.failed_items) {
            const product_found = this.product_selected_list.find(i => i.product.itemid === item.item_id)
            if (product_found) {
              const model_found = product_found.model_list.find(i => i.modelid === item.model_id)
              if (model_found) {
                // product_found.product.enable = false
                // model_found.enable = false
                model_found.error_message = `${this.$t('flash_sale.api_error_response')}: ${item.err_msg}`
              }
            }
          }
        }

        if (resp && resp.data && resp.data.warning_items) {
          for (const item of resp.data.warning_items) {
            const product_found = this.product_selected_list.find(i => i.product.itemid === item.item_id)
            if (product_found) {
              const model_found = product_found.model_list.find(i => i.modelid === item.model_id)
              if (model_found) {
                // product_found.product.enable = false
                // model_found.enable = false
                model_found.error_message += `${this.$t('flash_sale.attention_when_create')}: ${item.err_msg}`
              }
            }
          }
        }

        this.save_and_apply_successfully = true
      }

      if (ntf && !has_error) this.ntf_s(this.$t('flash_sale.updated_message'))
      this.loading.save_and_apply = false
    },

    async m__delete_item(item) {
      const form = {
        flash_sale_id: this.flash_sale.flash_sale_id,
        items: []
      }
      for (const model of item.model_list) {
        form.items.push({
          item_id: item.product.itemid,
          model_id: model.modelid,
          // price: model.discount_price,
          input_promo_price: +model.discount_price,
          purchase_limit: 0,
          status: 2,
          stock: +model.stock
        })
      }
      await this.seller.flash_sale_save_batch_items(form)
    },

    async m__remove_flash_sale_file_product(item) {
      try {
        await this.$confirm(this.$t('base.delete_product_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
        this.flash_sale_file_product_list = this.flash_sale_file_product_list.filter(i => i.product.itemid !== item.product.itemid)
        await this.m__delete_item(item)
      } catch (e) {
      }
    }
  }
}
</script>

<style lang="scss">
.disabled-text {
  color: #ccccd6 !important;
}

.table tr td {
  border-top: 1px solid white !important;
}

.sticky {
  position: fixed;
  top: 0;
  z-index: 999;

  p, br {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/flash_sale/edit.vue